<template>
  <div class="editworkinfo">
    <!-- <div class="van-cell van-field van-field--error">
      <div class="van-cell__title van-field__label">
        <span>公司名称</span>
      </div>
      <div class="van-cell__value">
        <div class="van-field__body">
          <input type="text" placeholder="请输入公司名称" class="" />
        </div>
      </div>
    </div>

    <div class="van-cell van-field van-field--error">
      <div class="van-cell__title van-field__label">
        <span>工作时间</span>
      </div>
      <div class="van-cell__value">
        <div class="van-field__body">
          <span class="" @click="sel_startime">{{startime?startime:'请选择开始时间'}}&nbsp;-&nbsp;</span>
          <span class="" @click="sel_endtime"> {{endtime?endtime:'请选择结束时间'}}</span>
        </div>
      </div>
    </div>-->

    <van-cell-group>
      <van-field
        v-model="tech.work_experience"
        rows="2"
        autosize
        type="textarea"
        placeholder="请输入工作经历"
        show-word-limit
      />
    </van-cell-group>
    
    <div class="btn_box">
      <button class="save_btn" @click="save">保存</button>
    </div>

  </div>
</template>

<script>
export default {
  name: "editworkinfo",
  components: {},
  data() {
    return {
      tech:[]
    };
  },
  created() {
    this.init();
  },
  methods: {
    init(){
      this.get_tech();
    },
    get_tech(){
      this.axios({
        url: this.api.tech.get_tech,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.tech = res.tech;
        }
      });
    },
    save(){
      this.axios({
        url: this.api.tech.update_tech_work,
        data: {tech_id:this.tech.id,work_experience:this.tech.work_experience}
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            message: res.msg,
            type: "success"
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.btn_box {
  text-align: center;
}
.save_btn {
  color: white;
  background-color: #45b9bc;
  border-radius: 5px;
  padding: 0.4rem 4rem;
  margin-top: 3.5rem;
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/perData/editworkinfo.vue